export const cloudinaryConfig = {
  cloudName: 'dzuppkxqa',
  uploadPreset: 'ml_default',
};
